import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
// api
import Api from '@/api'
import {AppType} from '@/enum'
import {IsManagerPro} from '@/utils'


/**
 * 汇通表单项
 * @constructor
 */
const HwhtFormItems = () => {

  return (
    <>
      <ProFormText
        name={["config", "authId"]}
        label={"企业编码"}
        placeholder={"请输入企业编码"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入企业编码"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormSelect
        name={['config', 'type']}
        label={"版本"}
        width={"lg"}
        valueEnum={{
          "V3": "V3"
        }}
        initialValue={"V3"}
      />
      {/*<ProFormText
        name={["config", "publicKey"]}
        label={"公钥"}
        placeholder={"请输入公钥"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请输入公钥"
        }]}
      />
      <ProFormText
        name={["config", "privateKey"]}
        label={"私钥"}
        placeholder={"请输入私钥"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请输入私钥"
        }]}
      />*/}
      <ProFormText
        name={["config", "aesKey"]}
        label={"aes解密key"}
        placeholder={"请输入aesKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入aesKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "nonce"]}
        label={"nonce"}
        placeholder={"请输入nonce"}
        required
        width={"lg"}
        rules={[
          {
          required: true,
          message: "请输入nonce"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormSelect
        name={["config", "envId"]}
        initialValue={2}
        label={"环境地址"}
        placeholder={"请选择所属环境地址"}
        required
        hidden={!IsManagerPro}
        width={"lg"}
        rules={[{
          required: true,
          message: "请选择所属环境地址"
        }]}
        fieldProps={{
          fieldNames: {
            label: "envName",
            value: "id"
          }
        }}
        request={async () => {
          const _data: any = await Api.Common.EnvList({appType: AppType.HWHT})
          return _data
        }}
      />
    </>
  )
}

export default HwhtFormItems
